// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".error__trbH2{color:#e74c3c;font-weight:500;display:flex;justify-content:center;width:100%;padding-top:10%}\n", "",{"version":3,"sources":["/home/runner/work/honeylove-web/honeylove-web/src/components/Fallback.module.scss"],"names":[],"mappings":"AAAA,cACE,aAAc,CACd,eAAgB,CAChB,YAAa,CACb,sBAAuB,CACvB,UAAW,CACX,eAAgB","file":"Fallback.module.scss","sourcesContent":[".error {\n  color: #e74c3c;\n  font-weight: 500;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  padding-top: 10%;\n}\n"]}]);
// Exports
exports.locals = {
	"error": "error__trbH2"
};
module.exports = exports;
